import Entity from './entity';
export default Entity.extend({
  precedence: 1,
  type: 'italic',
  tagName: 'i',
  attributesToCopy: ['startIndex', 'endIndex'],
  options: {}
}).reopenClass({
  tagName: 'I'
});